import React from "react";

export default function Banner2({ banners }) {
  const BaseUrl = process.env.REACT_APP_BASE_URL || "";
  if (!banners?.banner5) return null;

  return (
    <section className="relative w-full font-archivo">
      <div
        className="relative w-full min-h-[300px] md:min-h-[450px] lg:min-h-[450px] bg-contain bg-center bg-no-repeat overflow-hidden"
        style={{
          backgroundImage: `url("${BaseUrl}/${banners.banner5}")`,
        }}
      />
    </section>
  );
}
